/**
 * Farm Made — "Add one & save 10%" stays inside the cart drawer.
 *
 * snippets/tax-info.liquid renders the bundle nudge as a plain form that POSTs to /cart/update with
 * return_to=/cart. That works without JavaScript, but it throws a shopper out of the drawer onto the
 * cart page at the exact moment they were about to check out.
 *
 * This intercepts that submit and presses the line item's own "+" button instead, so the theme adds the
 * second unit through its normal cart flow and re-renders the drawer in place. The nudge only renders when
 * the cart holds exactly one item, so there is exactly one "+" to press. If none is found, the form falls
 * back to its normal POST.
 *
 * Loaded globally from snippets/scripts.liquid: the drawer's HTML arrives through the Section Rendering
 * API after an add-to-cart, and inline scripts inside that HTML never execute.
 */
(function () {
  'use strict';

  if (window.__fmoCartBundleLoaded) return;
  window.__fmoCartBundleLoaded = true;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('fmo-bundle__form')) return;

      var scope = form.closest('cart-items-component') || form.closest('dialog') || document;
      var plus = scope.querySelector('button.quantity-plus:not([disabled])');
      if (!plus) return;

      event.preventDefault();

      var button = form.querySelector('button');
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }

      plus.click();
    },
    true
  );
})();